import React from 'react'

import { SinglePanePage, screenSize } from 'styles/shared'
import styled from 'styled-components'

import Modal from 'components/Modal'

import FeaturesBox from './FeaturesBox'
import { color } from 'styles/colors'

type Props = {
  closeCallback: (reload: boolean) => void
}

const PremiumFeaturesModal = ({ closeCallback } : Props) => {
  return (
    <Modal variant="sm" isDisplayed closeCallback={() => closeCallback(false)} title="">
      <S.Top />
      <SinglePanePage>
        <S.Features>
          <FeaturesBox isBasicList enableCompareMode />
          <S.CurrentPlan>
            <S.PlanTitle><i>Your Current Plan</i></S.PlanTitle>
            <S.FeaturesBox isBasicList={false} enableCompareMode />
          </S.CurrentPlan>
        </S.Features>
      </SinglePanePage>
    </Modal>
  )
}

export default PremiumFeaturesModal

const S = {
  Features: styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    @media ${screenSize.small} {
      display: flex;
      gap: 40px;
      flex-direction: column;
      height: 1050px;
    }
  `,
  PlanTitle: styled.div`
    width: 100%;
    text-align: center;
    font-size: 16px;
    position: absolute;
    top: -30px;
    color: ${color('secondaryText')};
  `,
  Top: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  `,
  CurrentPlan: styled.div`
    position: relative;
  `,
  FeaturesBox: styled(FeaturesBox)`
    height: 100%;
  `
}
